// temporary - todo auto increment with commit only for investabill + fetch from package.josn
export const APP_VERSION = '0.0.16';
